import Styled from "styled-components";

export const Container = Styled.div`
  padding: 2rem 0 0 0;
`;

export const Content = Styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  width: ${(props) => props.theme.width};
  max-width: calc(100% - 2.5rem);
  margin: 0 auto;
  border-radius: 1.25rem;
  border: 1px solid #373737;
  background: ${(props) => props.theme.colors.black};
  overflow: hidden;

  ${(props) => props.theme.breakpoints.up("medium")} {
    max-width: calc(100% - 3rem);
    justify-content: space-between;
  }

  ${(props) => props.theme.breakpoints.up("large")} {
    max-width: calc(100% - 10rem);
    gap: 1rem;
  }
`;

export const Message = Styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 1rem;
  padding: 2rem;
  color: white;
  
  ${(props) => props.theme.breakpoints.up("medium")} {
    flex: 0.5;
    justify-content: center;
    align-items: flex-start;
  }

  ${(props) => props.theme.breakpoints.up("large")} {
    padding: 0;
    margin-left: 4rem;
  }
`;

export const Tagline = Styled.p`
  font-size: 1.25rem;
  line-height: 1.5625rem;
  font-weight: 400;
  letter-spacing: -0.2px;
  text-align: center;
  margin: 0 0 1rem;

  ${(props) => props.theme.breakpoints.up("medium")} {
    font-size: 1.25rem;
    text-align: start;
  }

  ${(props) => props.theme.breakpoints.up("xlarge")} {
    font-size: 1.624rem;
    line-height: 2rem;
    text-align: start;
  }
`;

export const Link = Styled.a`
  text-decoration: none;
`;

export const IllustrationContainer = Styled.div`
  overflow: hidden;
  display: none;
  justify-content: center;
  align-items: center;
  min-height: 10rem;
  min-width: 50%;

  ${(props) => props.theme.breakpoints.up("medium")} {
    display: flex;
    flex: 0.5;
    min-width: 52%;
    align-self: stretch;
  }
  
  ${(props) => props.theme.breakpoints.up("large")} {
    display: flex;
    flex: 0.5;
    min-width: 0;
  }
`;

export const Illustration = Styled.img`
  width: 100%;
  height: 100%;
  object-fit: cover;
  object-position: center center;
`;
